import { X } from 'lucide-react';

interface SlashPillProps {
  command: 'create' | 'revise';
  onClear: () => void;
}

const COLORS: Record<SlashPillProps['command'], { bg: string; text: string; border: string }> = {
  create: {
    bg: 'rgba(224,123,84,0.12)',
    text: 'var(--color-warning-text, #c2622a)',
    border: 'rgba(224,123,84,0.3)',
  },
  revise: {
    bg: 'rgba(78,168,222,0.12)',
    text: 'var(--color-info-text, #2a7fa8)',
    border: 'rgba(78,168,222,0.3)',
  },
};

export function SlashPill({ command, onClear }: SlashPillProps) {
  const c = COLORS[command];
  return (
    <span
      className="inline-flex shrink-0 items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold"
      style={{ background: c.bg, color: c.text, border: `1px solid ${c.border}` }}
    >
      {command.charAt(0).toUpperCase() + command.slice(1)}
      <button
        type="button"
        onClick={onClear}
        aria-label={`Remove /${command} mode`}
        className="flex items-center rounded-full p-0.5 transition-opacity hover:opacity-70"
        style={{ color: c.text }}
      >
        <X size={10} strokeWidth={2.5} />
      </button>
    </span>
  );
}
